import * as Common from '@tfo/common'
import { Loader } from '@tfo/common'
import { TfoCookie } from '@tfo/common/src/utils'
import LZstring from 'lz-string'
import { useStore } from '../../../hooks/useStore'

const LoginWithSsoRedirect = () => {
    const rootStore = useStore()
    const params = new URLSearchParams(window.location.search)
    const body = params.get('lr')
    if (!body) {
       window.location.href = '/login'
    }

    const parsedBody = LZstring.decompressFromEncodedURIComponent(body)
    const data = JSON.parse(parsedBody) as TfoCookie

    //we do this during password login, so 
    data.lastActivity = new Date().toLocaleDateString('sv-SE')
    Common.utils.setCookie(JSON.stringify(data))

    rootStore.login().then(() => {
        window.location.href = '/start'
    })

    return <Loader />
}

export default LoginWithSsoRedirect;